<table>
    <ng-container *ngFor="let row of rows">
        <ng-container *ngIf="row.rowType === 'TableHead'">
            <thead>
                <tr class="flex-container black-border-down">
                    <th class="flex-row header movement-name big-font">
                        <div stylePreference [textColor]="styleOptions?.tableHeaderColor" backgroundColor="white">{{ row.t }}</div>
                    </th>
                    <ng-container *ngFor="let columnName of columnNames">
                        <th
                            class="flex-row header"
                            [ngClass]="{
                                'big-font': columnNames.length <= maxFlisLengthForBigFontSize
                            }"
                            stylePreference
                            backgroundColor="white"
                        >
                            <div stylePreference [textColor]="styleOptions?.tableHeaderColor">
                                <span> {{ columnName }} </span>
                            </div>
                        </th>
                    </ng-container>
                </tr>
            </thead>
        </ng-container>
        <tbody>
            <ng-container *ngIf="row.rowType === 'GroupTotal' || row.rowType === 'TableTotal'">
                <tr class="flex-container grey-background black-border-down black-border-top">
                    <td
                        class="flex-row text movement-name"
                        [ngClass]="{ 'big-font': columnNames.length <= maxFlisLengthForBigFontSize }"
                    >
                        <div stylePreference [textColor]="styleOptions?.tableFooterColor">
                            <span>{{ row.t }}</span>
                        </div>
                    </td>
                    <ng-container *ngFor="let columnName of columnNames; let index = index">
                        <td
                            class="flex-row text"
                            [ngClass]="{
                                'big-font': columnNames.length <= maxFlisLengthForBigFontSize
                            }"
                        >
                            <div stylePreference [textColor]="styleOptions?.tableFooterColor">
                                <span>
                                    {{ row['col' + (index + 1)] }}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'Row'">
                <tr class="flex-container gray-border-down">
                    <td
                        class="flex-row text movement-name"
                        [ngClass]="{
                            'big-font': columnNames.length <= maxFlisLengthForBigFontSize
                        }"
                    >
                        <div stylePreference [textColor]="styleOptions?.textColor" backgroundColor="white">
                            <span> {{ row.t }} </span>
                        </div>
                    </td>
                    <ng-container *ngFor="let columnName of columnNames; let index = index">
                        <td
                            class="flex-row text"
                            [ngClass]="{
                                'big-font': columnNames.length <= maxFlisLengthForBigFontSize
                            }"
                            stylePreference
                            backgroundColor="white"
                        >
                            <div stylePreference [textColor]="styleOptions?.textColor">
                                <span>
                                    {{ row['col' + (index + 1)] }}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
        </tbody>
    </ng-container>
</table>
